import React from 'react'

import { LoadingDots } from 'components/LoadingDots'
import { Progress } from 'components/Progress'

import { StyledLoadingProgress as S } from './LoadingProgress.styles'

type TLoadingProgressProps = {
  loadingLabel: React.ReactNode
  progressLabel: React.ReactNode
  value: number
  labelColor?: string
  hasWhiteTrack?: boolean
  isLabelHidden?: boolean
}

export const LoadingProgress: React.FC<TLoadingProgressProps> = ({
  loadingLabel,
  progressLabel,
  value,
  labelColor,
  hasWhiteTrack = false,
  isLabelHidden = false,
}) => (
  <>
    <S.Loading $labelColor={labelColor} $isHidden={isLabelHidden}>
      {loadingLabel}
      <LoadingDots />
    </S.Loading>

    <S.ProgressWrapper $hasWhiteTrack={hasWhiteTrack}>
      <S.ProgressInner>
        <Progress
          background="transparent"
          color="linear-gradient(90deg, #BB8300 0%, #FFC15E 100%)"
          roundedAllSides
          value={value}
          max={100}
        />
      </S.ProgressInner>

      <S.ProgressText>{progressLabel}</S.ProgressText>
    </S.ProgressWrapper>
  </>
)
